import React from "react";
import { Form, Input, Button, Select } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import axios from "../../services/axiosConfig";
import Helper from "../../services/Helper";
import Notification from "../../services/Notification";

const courierCompanies = [
  {
    label: "Professional Courier",
    value: "Professional Courier",
    trackingUrl: "https://www.tpcindia.com/",
  },
  {
    label: "Trackon",
    value: "Trackon",
    trackingUrl: "https://www.trackon.in/courier-tracking",
  },
  {
    label: "Delhivery",
    value: "Delhivery",
    trackingUrl: "https://www.delhivery.com/tracking",
  },
  {
    label: "Xpressbees",
    value: "Xpressbees",
    trackingUrl: "https://www.xpressbees.com/track-shipment",
  },
  {
    label: "Amazon",
    value: "Amazon",
    trackingUrl: "https://shipping.amazon.in/",
  },
  {
    label: "Bluedart",
    value: "Bluedart",
    trackingUrl: "https://www.bluedart.com/tracking",
  },
  {
    label: "DTDC",
    value: "DTDC",
    trackingUrl: "https://www.dtdc.com/track-your-shipment/",
  },
  {
    label: "Shadowfax",
    value: "Shadowfax",
    trackingUrl: "https://www.shadowfax.in/track",
  },
];

const courier = () => {
  const onFinish = async (values) => {
    let data = await axios
      .patch("/update-courier", {
        ordersId: Number(values.ordersId),
        trackingId: values.trackingId,
        courierCompany: values.courierCompany,
        trackingUrl: courierCompanies.find(
          (company) => company.value === values.courierCompany,
        ).trackingUrl,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) {
      Notification.success("Tracking ID updated Successfully");
    }
  };

  return (
    <Container fluid>
      <div className="settings-pg">
        <Row>
          <Col md={12}>
            <Form
              layout={"vertical"}
              onFinish={onFinish}
              initialValues={{
                courierCompany: courierCompanies[0].value,
              }}
            >
              <Form.Item
                label="Courier Company"
                name="courierCompany"
                rules={[
                  {
                    required: true,
                    message: "Courier company is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select courier company"
                  options={courierCompanies}
                />
              </Form.Item>

              <Form.Item
                label="Order ID"
                name="ordersId"
                rules={[
                  {
                    required: true,
                    message: "Order ID is required",
                  },
                ]}
              >
                <Input placeholder="Enter Order ID" />
              </Form.Item>
              <Form.Item
                label="Tracking ID"
                name="trackingId"
                rules={[
                  {
                    required: true,
                    message: "Tracking ID is required",
                  },
                ]}
              >
                <Input placeholder="Enter Tracking ID" />
              </Form.Item>
              <Form.Item style={{ textAlign: "left" }}>
                <Button type="primary" htmlType="submit">
                  Update
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default courier;
